<script>
  import { getPreviewMeta } from './preview-meta.js';

  export let preview = '';
  export let className = '';
  export let showIcon = true;
  export let compact = true;
  export let frosted = true;

  $: meta = getPreviewMeta(preview, { fallbackText: 'Chưa có tin nhắn' });
</script>

<div class={`preview-line ${compact ? 'compact' : ''} ${frosted ? 'frosted' : ''} ${className}`}>
  {#if showIcon}
    <span class={`preview-icon ${meta.color}`}>
      <svelte:component this={meta.icon} size={13} />
    </span>
  {/if}

  <div class="preview-copy">
    <span class="preview-badge hidden">{meta.badge}</span>
    <span class="preview-text">{meta.text}</span>
    {#if meta.secondary}
      <span class="preview-secondary">{meta.secondary}</span>
    {/if}
  </div>
</div>

<style>
  .preview-line {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    min-width: 0;
    margin-top: 0.22rem;
    color: #64748b;
    font-size: 0.74rem;
    line-height: 1.35;
  }

  .preview-line.compact {
    font-size: 0.71rem;
  }

  .preview-line.frosted {
    padding: 0.18rem 0.1rem;
  }

  .preview-icon {
    display: grid;
    flex: 0 0 auto;
    place-items: center;
    width: 1.38rem;
    height: 1.38rem;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.52);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.38);
    backdrop-filter: blur(18px);
  }

  .preview-icon.sky {
    color: #0284c7;
    background: rgba(224, 242, 254, 0.72);
  }
  .preview-icon.rose {
    color: #e11d48;
    background: rgba(255, 228, 230, 0.72);
  }
  .preview-icon.amber {
    color: #c2410c;
    background: rgba(255, 237, 213, 0.78);
  }
  .preview-icon.emerald {
    color: #047857;
    background: rgba(209, 250, 229, 0.74);
  }
  .preview-icon.cyan {
    color: #0f766e;
    background: rgba(204, 251, 241, 0.76);
  }
  .preview-icon.violet {
    color: #7c3aed;
    background: rgba(237, 233, 254, 0.76);
  }
  .preview-icon.slate {
    color: #475569;
    background: rgba(241, 245, 249, 0.82);
  }

  .preview-copy {
    display: flex;
    align-items: center;
    gap: 0.38rem;
    min-width: 0;
    flex-wrap: wrap;
  }

  .preview-badge {
    flex: 0 0 auto;
    padding: 0.18rem 0.46rem;
    border: 1px solid rgba(255, 255, 255, 0.28);
    border-radius: 999px;
    color: #0f172a;
    background: rgba(255, 255, 255, 0.54);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4);
    backdrop-filter: blur(18px);
    font-size: 0.62rem;
    font-weight: 700;
    letter-spacing: 0.02em;
  }

  .preview-text,
  .preview-secondary {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .preview-text {
    color: #475569;
  }

  .preview-secondary {
    color: #94a3b8;
  }

  @media (max-width: 640px) {
    .preview-copy {
      gap: 0.28rem;
    }

    .preview-secondary {
      display: none;
    }
  }
</style>
